import { createDefaultRecipientRoleFieldBase } from './default-recipient-role-field'
import { FieldEnum, FieldTypeEnum, SelectedFieldEnum } from './fields.dto'

export const DatepickerField = {
    tag(field) {
        return {
            ...createDefaultRecipientRoleFieldBase(field, true),
            field_name: "Datepicker",
            field: FieldEnum.DatepickerField,
            type: FieldTypeEnum.Datepicker,
            selected_field: SelectedFieldEnum.DatepickerField,
            alt_value: field.alt_value ?? ""
        }
    }
}